import { SOCKET } from 'flaivy-react/reducers/action-type';

function alertListReducerDecorator(reducer) {
  return (state, action) => {
    const newState = reducer(state, action);
    if (action.type === SOCKET('ALERT_CLOSED')) {
      const entity = action.payload.fullEntity;
      const entities = newState.entities.filter(x => x.id !== entity.id);
      const total = newState.total > 0 ? newState.total - 1 : 0;
      return {
        ...newState,
        entities,
        total,
        updating: false,
        updateSuccess: true,
      };
    }
    return newState;
  };
}

export default alertListReducerDecorator;
